import React, { useCallback } from 'react';
import { useDispatch, useSelector, RootStateOrAny } from 'react-redux';
import { useTranslation } from 'react-i18next';

import Button from '@components/Button';
import { openPopUp } from '@containers/App/containers/PopUp/actions';
import POPUP_TYPES from '@containers/App/containers/PopUp/types';

interface UpdateMfaButtonProps {
  userId: string;
  userEmail?: string;
  phone?: string | null;
}

const UpdateMfaButton: React.FC<UpdateMfaButtonProps> = ({ userId, userEmail, phone }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const loading = useSelector((state: RootStateOrAny) => state.getIn(['userPage', 'loading']));

  const onClick = useCallback(() => {
    if (!userId) return;
    dispatch(openPopUp(POPUP_TYPES.SELECT_MFA_METHOD, {
      userId,
      userEmail,
      phone,
      source: 'user',
      disableBackdrop: true,
    }));
  }, [dispatch, phone, userEmail, userId]);

  return (
    <Button color="primary" disabled={Boolean(loading)} onClick={onClick}>
      {t('Authentication.MFA.adminButtonLabel', 'Update MFA')}
    </Button>
  );
};

export default UpdateMfaButton;
